import { setSpecificMessage, notLength } from "valibot";
setSpecificMessage(
  notLength,
  (issue) => `Longeur invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);